import { forwardRef } from "react";
import { Link } from "react-router-dom";
import { MenuItem, MenuItems } from "@headlessui/react";
import { classNames } from "@/components/Layout";
import { UserDropdownMenuProps } from "./userDropdownMenu.types";

export const UserDropdownMenu = forwardRef<
  HTMLDivElement,
  UserDropdownMenuProps
>(({ user, onSignOut }, ref) => {
  return (
    <MenuItems
      ref={ref}
      className="origin-top-right absolute right-0 mt-2 w-60 rounded-xl shadow-raro-lg py-1 bg-white ring-1 ring-primary-100 focus:outline-none border"
    >
      {/* User Info */}
      <div className="px-4 py-3 text-sm text-raro-gray-700 border-b">
        <p className="font-semibold font-montserrat text-raro-gray-900 truncate">
          {user?.displayName || "Usuário"}
        </p>
        <p className="text-xs text-raro-gray-500 font-montserrat mt-1 truncate">
          {user?.email}
        </p>
      </div>

      {/* Menu Items */}
      <MenuItem>
        {({ active }) => (
          <Link
            to="/me/atualizar-cadastro"
            className={classNames(
              active ? "bg-primary-50 text-primary-700" : "text-raro-gray-700",
              "block px-4 py-2 text-sm font-montserrat font-medium transition-colors"
            )}
          >
            Atualizar Cadastro
          </Link>
        )}
      </MenuItem>

      <MenuItem>
        {({ active }) => (
          <button
            onClick={onSignOut}
            className={classNames(
              active ? "bg-red-50 text-red-700" : "text-raro-gray-700",
              "block w-full text-left px-4 py-2 text-sm font-montserrat font-medium transition-colors"
            )}
          >
            Sair
          </button>
        )}
      </MenuItem>
    </MenuItems>
  );
});

export default UserDropdownMenu;
